import React, { useState, useEffect } from 'react';
import { fetchOrderHistory } from '../api';
import { Link } from 'react-router-dom';

function OrderHistoryPage() {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedOrders, setExpandedOrders] = useState({});

  useEffect(() => {
    const getOrders = async () => {
      try {
        const response = await fetchOrderHistory();
        setOrders(response.data);
        setIsLoading(false);
      } catch (err) {
        console.error('Error fetching orders:', err);
        setError('Failed to load order history. Please try again later.');
        setIsLoading(false);
      }
    };

    getOrders();
  }, []);

  const toggleOrderExpand = (orderId) => {
    setExpandedOrders(prev => ({
      ...prev,
      [orderId]: !prev[orderId]
    }));
  };

  if (isLoading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-600">{error}</div>;
  }

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-4xl font-bold text-center mb-8">Order History</h1>
      
      {orders.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-lg mb-4">You don't have any orders yet.</p>
          <Link to="/" className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600">
            Start Shopping
          </Link>
        </div>
      ) : (
        orders.map(order => (
          <div key={order.order_id} className="mb-6 bg-white rounded-lg shadow-sm overflow-hidden">
            <div 
              className="flex justify-between items-center p-4 cursor-pointer bg-purple-50 hover:bg-purple-100"
              onClick={() => toggleOrderExpand(order.order_id)}
            >
              <div>
                <span className="font-bold">Order #{order.order_id}</span>
                <span className="ml-6 text-gray-600">{new Date(order.order_date).toLocaleDateString()}</span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold mr-4">${parseFloat(order.total_amount).toFixed(2)}</span>
                <span className="text-xl">
                  {expandedOrders[order.order_id] ? '▲' : '▼'}
                </span>
              </div>
            </div>
            
            {expandedOrders[order.order_id] && (
              <div className="p-4">
                <div className="grid grid-cols-6 gap-4 text-center font-semibold mb-2 px-4 py-2 bg-purple-100 rounded-lg">
                  <div>Image</div>
                  <div>Product Name</div>
                  <div>Size</div>
                  <div>Price</div>
                  <div>Quantity</div>
                  <div>Subtotal</div>
                </div>
                
                {order.items.map(item => (
                  <div key={item.item_id} className="grid grid-cols-6 gap-4 text-center items-center py-4 border-b border-purple-200">
                    <div className="flex justify-center">
                      <img 
                        src={item.image_url} 
                        alt={item.name} 
                        className="w-16 h-16 object-cover rounded-md"
                      />
                    </div>
                    <div>{item.name}</div>
                    <div>{item.size || 'N/A'}</div>
                    <div>${parseFloat(item.price).toFixed(2)}</div>
                    <div>{item.quantity}</div>
                    <div>${(parseFloat(item.price) * item.quantity).toFixed(2)}</div>
                  </div>
                ))}
                
                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                  <h3 className="font-semibold mb-2">Shipping Information</h3>
                  <p>{order.shipping_info.firstName} {order.shipping_info.lastName}</p>
                  <p>{order.shipping_info.address}</p>
                  <p>{order.shipping_info.city}, {order.shipping_info.state} {order.shipping_info.areacode}</p>
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default OrderHistoryPage;
